export default {
  BEFORE_UNAUTHORIZE: 'unauthorize',
  AFTER_UNAUTHORIZE: 'unauthorize',
  USER_INFO_EXPIRED: 'userinfoexpired'
};



// WEBPACK FOOTER //
// ./src/common/auth/Events.js